module.exports = __webpack_public_path__ + "img/yywy-2.9e4b8d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yywy-2.jpg
// module id = YpF5
// module chunks = 0